<template>
  <div class="login-register" style="background-image:url(assets/images/background/login-register.jpg);">
    <div class="login-box card">
      <div class="card-body">
        <VeeForm :validation-schema="loginSchema" @submit="onSubmit" class="form-horizontal form-material">
          <h3 class="box-title m-b-20">ログイン</h3>
          <div class="form-group">
            <div class="col-xs-12">
              <VeeField name="login_id" v-slot="{ field, errors }">
                <input class="form-control" type="text"
                       v-bind="field"
                       maxlength="20">
                <small class="form-control-feedback" v-if="errors.length > 0">
                  {{ errors[0] }}
                </small>
              </VeeField>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <VeeField name="password" v-slot="{ field, errors }">
                <input class="form-control" type="password"
                       v-bind="field"
                       maxlength="20">
                <small class="form-control-feedback" v-if="errors.length > 0">
                  {{ errors[0] }}
                </small>
              </VeeField>
            </div>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                      type="submit"
                      :disabled="isProcessing">
                <template v-if="isProcessing">
                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  Loading...
                </template>
                <template v-else>
                  ログイン
                </template>
              </button>
            </div>
          </div>
        </VeeForm>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { loginSchema } from '@/plugins/vee-validate/schema'
import ApiError from '../../libs/ApiError'

const store = useStore()
const router = useRouter()
const isProcessing = ref(false)

const onSubmit = async (values, { setFieldError }) => {
  if (isProcessing.value) return
  try {
    isProcessing.value = true
    await store.dispatch('session/loginAsync', {
      loginId: values.login_id,
      password: values.password
    })
    router.replace('/plan')
  } catch (error) {
    if (ApiError.isStatusEquals(error, 401)) {
      setFieldError('login_id', 'ログインIDまたはパスワードが正しくありません。')
      console.error('ログインIDまたはパスワードが正しくありません。')
    } else {
      throw error
    }
  } finally {
    isProcessing.value = false
  }
}
</script>

<style scoped>
 .form-control-feedback {
   color: #fc4b6c;
 }
</style>
